import BackendAPIService from './BackendAPIService'
import assert from 'shared/utils/assert'

class SellerService extends BackendAPIService {
  getSellerDataPath(id) {
    return `/cacheable/seller/v1/${this.tenantPath}/${id}`
  }

  async fetchSellerData(id) {
    assert(id, 'sellerService.fetchSellerData: id missing')
    this.logger.debug(`Fetching seller ${id}`, 'dataFetching')
    const { data } = await this.get(this.getSellerDataPath(id))
    this.logger.debug(`Seller ${id} fetched!`, 'dataFetching')
    return data
  }
}

export default SellerService
